<template>
    <div v-if="IsValidRequestCheckout" class="section-content-checkout-wrapper">
        <!-- Loading -->
        <loading />

        <!-- Checkout Steps -->
        <header class="checkout-nav">
            <nav>
                <ul class="checkou-steps-wrapper" ref="checkoutnav">
                    <li data-routine="pdp" role="button" class="checkou-step">
                        <div
                            @click="buttonActions($event)"
                            data-routine="pdp"
                            class="checkou-step-item"
                        >
                            <span class="checkout-pdp" data-routine="pdp">
                                <img
                                    data-routine="pdp"
                                    :src="checkoutnavicondone"
                                    alt="Checkou Nav Icon"
                                />
                            </span>
                            <p class="caption-lg" data-routine="pdp">Escolha</p>
                        </div>
                    </li>

                    <div class="line"></div>

                    <li
                        data-routine="details"
                        role="button"
                        class="checkou-step"
                    >
                        <div
                            @click="buttonActions($event)"
                            data-routine="details"
                            class="checkou-step-item"
                        >
                            <span
                                class="checkout-details"
                                data-routine="details"
                            >
                                <img
                                    data-routine="details"
                                    :src="checkoutnaviconcurrent"
                                    alt="Checkou Nav Icon"
                                />
                            </span>
                            <p class="caption-lg" data-routine="details">
                                Detalhes
                            </p>
                        </div>
                    </li>

                    <div class="line"></div>

                    <li
                        data-action="process"
                        data-routine="payment"
                        role="button"
                        class="checkou-step"
                    >
                        <div
                            data-routine="payment"
                            data-action="process"
                            class="checkou-step-item"
                            @click="buttonActions($event)"
                        >
                            <span
                                class="checkout-payment"
                                data-action="process"
                                data-routine="payment"
                            >
                                <img
                                    data-routine="payment"
                                    data-action="process"
                                    src=""
                                    alt=""
                                />
                            </span>
                            <p
                                class="caption-lg"
                                data-action="process"
                                data-routine="payment"
                            >
                                Pagamento
                            </p>
                        </div>
                    </li>
                </ul>
            </nav>
        </header>

        <!-- Checkout Base -->
        <div class="checkout-base-content">
            <!-- SideBar -->
            <aside class="sidebar-checkout">
                <!-- Base -->
                <div class="sidebar-base">
                    <!-- Header -->
                    <header class="sidebar-header">
                        <figure>
                            <figcaption>
                                <p class="color-text-body">
                                    {{
                                        `${CheckoutData.booking.productdata.productdata.address}, ${CheckoutData.booking.productdata.productdata.postalcode}, ${CheckoutData.booking.productdata.productdata.location_name}`
                                    }}
                                </p>
                                <h1 class="heading-4">
                                    {{
                                        CheckoutData.booking.productdata
                                            .productdata.name
                                    }}
                                </h1>
                            </figcaption>

                            <img
                                :src="mediadata"
                                :alt="
                                    CheckoutData.booking.productdata.productdata
                                        .name
                                "
                            />
                        </figure>
                    </header>

                    <!-- Content -->
                    <div class="sidebar-content container">
                        <!-- Booking Details -->
                        <div class="list-content">
                            <p class="title-sidebar-section">
                                Detalhes da reserva:
                            </p>

                            <ul
                                class="list-group detail-reserve-list"
                                ref="detailreservelist"
                            ></ul>
                        </div>

                        <hr />

                        <!-- Total -->
                        <div class="checkout-total">
                            <div class="checkout-total-info">
                                <p class="color-text-body">Total:</p>
                                <h5 class="neutral-800">{{ total }} €</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </aside>

            <!-- Content -->
            <div class="content-checkout">
                <!-- Login -->
                <div
                    v-if="!CheckoutData.booking.userisloged"
                    class="login-content"
                >
                    <div class="icon-and-text">
                        <img
                            :src="`${imgdefaultpath}/person_icon_size_24.png`"
                            alt=""
                        />
                        <p>Já tens conta ?</p>
                    </div>

                    <button
                        @click="showModal('logincheckoutform')"
                        type="button"
                        class="btn btn-link"
                    >
                        <p class="button-body">Iniciar Sessão</p>
                    </button>
                </div>

                <!-- User Form -->
                <div
                    v-if="!showPaymentContent"
                    :class="!CheckoutData.booking.userisloged ? '' : ''"
                    class="form-content"
                >
                    <div class="form-title">
                        <h6>
                            {{
                                !CheckoutData.booking.userisloged
                                    ? "Insere os teus detalhes"
                                    : "Dados de faturação"
                            }}
                        </h6>
                    </div>

                    <div class="user-form">
                        <form
                            @submit.prevent="buttonActions($event)"
                            data-routine="payment"
                            :data-action="
                                CheckoutData.booking.userisloged
                                    ? 'process'
                                    : 'create'
                            "
                            class="row"
                            autocomplete="on"
                            method="post"
                            aria-describedby="Checkout Professional Form"
                        >
                            <div class="input-label-wrapper">
                                <label for="name" class="form-label"
                                    >Nome Completo*</label
                                >
                                <input
                                    @focusin="inputValidationCase('name', name)"
                                    @focusout="
                                        inputValidationCase('name', name)
                                    "
                                    type="text"
                                    class="form-control"
                                    id="name"
                                    placeholder=""
                                    v-model="name"
                                    maxlength="300"
                                />
                            </div>

                            <div class="input-label-wrapper">
                                <label for="name" class="form-label"
                                    >Email*</label
                                >
                                <input
                                    @focusin="
                                        inputValidationCase('email', email)
                                    "
                                    @focusout="
                                        inputValidationCase('email', email)
                                    "
                                    type="text"
                                    class="form-control"
                                    id="email"
                                    placeholder=""
                                    v-model="email"
                                    maxlength="300"
                                />
                            </div>

                            <div
                                v-if="!CheckoutData.booking.userisloged"
                                class="input-label-wrapper"
                            >
                                <label for="contact" class="form-label"
                                    >Telemóvel*</label
                                >
                                <input
                                    @focusin="
                                        inputValidationCase('contact', contact)
                                    "
                                    @focusout="
                                        inputValidationCase('contact', contact)
                                    "
                                    type="text"
                                    class="form-control"
                                    id="contact"
                                    placeholder=""
                                    v-model="contact"
                                    maxlength="9"
                                />
                            </div>

                            <div class="input-label-wrapper">
                                <label for="address" class="form-label"
                                    >Morada*</label
                                >
                                <input
                                    @focusin="
                                        inputValidationCase('address', address)
                                    "
                                    @focusout="
                                        inputValidationCase('address', address)
                                    "
                                    type="text"
                                    class="form-control"
                                    id="address"
                                    placeholder=""
                                    v-model="address"
                                    maxlength="400"
                                />
                            </div>

                            <div class="input-label-wrapper double-input-row">
                                <div class="flex-1">
                                    <label for="postalcode" class="form-label"
                                        >Código Postal*</label
                                    >
                                    <input
                                        @focusin="
                                            inputValidationCase(
                                                'postalcode',
                                                postalcode
                                            )
                                        "
                                        @focusout="
                                            inputValidationCase(
                                                'postalcode',
                                                postalcode
                                            )
                                        "
                                        type="text"
                                        class="form-control"
                                        id="postalcode"
                                        v-model="postalcode"
                                        maxlength="8"
                                    />
                                </div>

                                <div class="flex-1">
                                    <label for="city" class="form-label"
                                        >Cidade*</label
                                    >
                                    <input
                                        @focusin="
                                            inputValidationCase('city', city)
                                        "
                                        @focusout="
                                            inputValidationCase('city', city)
                                        "
                                        type="text"
                                        class="form-control"
                                        id="city"
                                        v-model="city"
                                        maxlength="100"
                                    />
                                </div>
                            </div>

                            <div class="input-label-wrapper">
                                <label for="nif" class="form-label">NIF*</label>
                                <input
                                    @focusin="inputValidationCase('nif', nif)"
                                    @focusout="inputValidationCase('nif', nif)"
                                    type="text"
                                    class="form-control"
                                    id="nif"
                                    placeholder=""
                                    maxlength="9"
                                    v-model.number="nif"
                                />
                            </div>

                            <div
                                v-if="!CheckoutData.booking.userisloged"
                                class="input-label-wrapper"
                            >
                                <div class="form-check">
                                    <input
                                        @click="billingAddressIndicate()"
                                        class="form-check-input"
                                        type="checkbox"
                                        id="gridCheck"
                                        :checked="billingAddress"
                                    />
                                    <label
                                        class="form-check-label"
                                        for="gridCheck"
                                    >
                                        Utilizar estes dados para faturação
                                    </label>
                                </div>
                            </div>

                            <template v-if="!billingAddress">
                                <fieldset>
                                    <legend>Morada de Faturação</legend>

                                    <div class="flex-gap-separator">
                                        <div class="input-label-wrapper">
                                            <label
                                                for="address_billing"
                                                class="form-label"
                                                >Morada *</label
                                            >
                                            <input
                                                @focusin="
                                                    inputValidationCase(
                                                        'address_billing',
                                                        address_billing
                                                    )
                                                "
                                                @focusout="
                                                    inputValidationCase(
                                                        'address_billing',
                                                        address_billing
                                                    )
                                                "
                                                type="text"
                                                class="form-control"
                                                id="address_billing"
                                                placeholder=""
                                                v-model="address_billing"
                                                maxlength="400"
                                            />
                                        </div>

                                        <div
                                            class="input-label-wrapper double-input-row"
                                        >
                                            <div class="flex-1">
                                                <label
                                                    for="postalcode_billing"
                                                    class="form-label"
                                                    >Código Postal *</label
                                                >
                                                <input
                                                    @focusin="
                                                        inputValidationCase(
                                                            'postalcode_billing',
                                                            postalcode_billing
                                                        )
                                                    "
                                                    @focusout="
                                                        inputValidationCase(
                                                            'postalcode_billing',
                                                            postalcode_billing
                                                        )
                                                    "
                                                    type="text"
                                                    class="form-control"
                                                    id="postalcode_billing"
                                                    v-model="postalcode_billing"
                                                    maxlength="9"
                                                />
                                            </div>
                                            <div class="flex-1">
                                                <label
                                                    for="city_billing"
                                                    class="form-label"
                                                    >Cidade *</label
                                                >
                                                <input
                                                    @focusin="
                                                        inputValidationCase(
                                                            'city_billing',
                                                            city_billing
                                                        )
                                                    "
                                                    @focusout="
                                                        inputValidationCase(
                                                            'city_billing',
                                                            city_billing
                                                        )
                                                    "
                                                    type="text"
                                                    class="form-control"
                                                    id="city_billing"
                                                    v-model="city_billing"
                                                    maxlength="100"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </template>

                            <div class="">
                                <button
                                    data-routine="payment"
                                    type="submit"
                                    class="btn btn-primary w-100"
                                    :disabled="disabled"
                                >
                                    <p class="button-body">Pagamento</p>
                                    <img
                                        :src="`${imgdefaultpath}/keyboard_arrow_right_size_24_white.svg`"
                                        alt="arrow proceed"
                                    />
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- Payment Content -->
                <div v-else class="form-content">
                    <div class="w-100 form-title">
                        <h6>Métodos de pagamento</h6>
                    </div>

                    <div class="payment-form">
                        <form
                            @submit.prevent="sendData('payment')"
                            class="row w-100"
                            action=""
                            method="post"
                            aria-describedby="Checkout Payment Form"
                        >
                            <div
                                v-for="(value, index) in paymentMethods"
                                :key="value.id"
                                :data-referindex="index"
                                class="form-check"
                            >
                                <template v-if="value.active">
                                    <input
                                        @click="getPaymentMethod()"
                                        v-model="paymentindicate"
                                        class="form-check-input"
                                        type="radio"
                                        :name="`payment${value.id}`"
                                        :id="`payment${value.id}`"
                                        :value="value.viva_id"
                                    />
                                    <label
                                        class="form-check-label"
                                        :for="`payment${value.id}`"
                                    >
                                        <p class="button-body">
                                            <img :src="`${imgpaymentspath}/${value.icon}`" class="me-2" alt="Payment Icon"> {{ value.name }}
                                        </p>
                                    </label>
                                </template>
                            </div>

                            <div style="padding: 0">
                                <button
                                    type="submit"
                                    class="btn btn-primary w-100"
                                    :disabled="disabledpayment"
                                >
                                    Confirmar e pagar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Login Form -->
        <modal title="Login" classname="logincheckoutform">
            <template #modalcontent>
                <form
                    @submit.prevent="sendData('login')"
                    class="d-flex flex-column formcontent"
                    id="logincheckoutform"
                    method="post"
                    autocomplete="off"
                >
                    <div class="login-form-wrapper">
                        <h2>Já tens conta?</h2>
                        <div class="item-wrapper">
                            <label for="mailinput" class="form-label"
                                >Email</label
                            >
                            <input
                                @focusin="
                                    inputValidationCase('mailinput', loginmail)
                                "
                                @focusout="
                                    inputValidationCase('mailinput', loginmail)
                                "
                                v-model="loginmail"
                                type="email"
                                maxlength="300"
                                name="email"
                                class="form-control"
                                id="mailinput"
                                placeholder=""
                                aria-describedby="Inform your Email"
                                required
                            />
                        </div>

                        <div class="item-wrapper">
                            <label for="mailpassword" class="form-label"
                                >Palavra-passe</label
                            >
                            <div class="input-wrapper">
                                <input
                                    @focusin="
                                        inputValidationCase(
                                            'mailpassword',
                                            loginpass
                                        )
                                    "
                                    @focusout="
                                        inputValidationCase(
                                            'mailpassword',
                                            loginpass
                                        )
                                    "
                                    v-model="loginpass"
                                    type="password"
                                    maxlength="50"
                                    class="form-control mailpassword"
                                    name="password"
                                    id="mailpassword"
                                    placeholder=""
                                    aria-describedby="Inform your Password"
                                    ref="mailpassword"
                                    required
                                />
                                <span
                                    @click="
                                        showPass(
                                            this.$refs.mailpassword,
                                            $event
                                        )
                                    "
                                    data-show="true"
                                    role="button"
                                    class="showpass toggle-password caption-lg"
                                ></span>
                            </div>
                        </div>

                        <div class="btn-item-wrapper">
                            <button
                                class="btn btn-outline-primary btn-filled-blue button-body"
                                type="submit"
                                :disabled="disabledlogin"
                            >
                                Iniciar sessão
                            </button>

                            <button
                                @click="hideModal('logincheckoutform')"
                                type="button"
                                data-action="cancel"
                                class="btn btn-cancel button-body"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </form>
            </template>
        </modal>

        <!-- Contract -->
        <modal
            title="Contrato de arrendamento"
            classname="contractcheckoutform"
        >
            <template #modalreader>
                <p class="caption-lg" style="margin-top: 12px">
                    *Para avançar é necessário ler os termos abaixo
                </p>

                <p class="caption-lg" style="margin-top: 8px">
                    *Caso verifique que os dados pessoais estão incorretos,
                    clique neles para corrigi-los.
                </p>
            </template>
            <template #modalcontent>
                <contract
                    @form-data="getProfessionalAgreement($event)"
                    :contracttext="contract"
                />
            </template>
        </modal>

        <!-- Payment Response -->
        <modal title="" classname="checkoutpaymentresponse">
            <template #modalcontent>
                <div class="paymentresponse">
                    <h2 class="payment-title">Reserva</h2>

                    <div class="payment-content">
                        <h6>Pagamento em processamento</h6>
                        <p>
                            Em breve receberá um email com os detalhes da sua
                            reserva
                        </p>
                    </div>

                    <template v-if="paymentProcess">

                        <p class="mt-3">Caso não consiga ter acesso a nossa janela de pagamento por favor aceder ao 
                            <a :href="paymenturlplataform" target="_blank" aria-details="Payment Url">Link</a> 
                            para efetuar o pagamento da sua reserva</p>

                    </template>

                    <hr />

                    <template v-if="enablefeedback">
                        <div class="feedbackbase" ref="feedbackbase">
                            <h6>Como avalias o processo de reserva ?</h6>

                            <div class="feedback-list">
                                <div
                                    v-for="(val, index) in feedbackQuestion"
                                    :key="index"
                                    class="feedbackitens"
                                    :data-value="val.value"
                                    role="button"
                                    @click="sendFeedBackData($event)"
                                >
                                    <div
                                        class="feedbackitens-value"
                                        :data-value="val.value"
                                    >
                                        <div
                                            class="symbolelement"
                                            :data-symbolvalue="
                                                val.route.checkout.symbol
                                            "
                                            :data-value="val.value"
                                        >
                                            <span
                                                v-html="
                                                    val.route.checkout.symbol
                                                "
                                            ></span>
                                        </div>
                                        <p
                                            class="caption-md"
                                            :data-value="val.value"
                                        >
                                            {{ val.route.checkout.text.pt }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <p class="caption-md">
                                *A tua resposta servirá para melhorar a
                                experiência de utilização e o serviço que
                                prestamos
                            </p>
                        </div>
                    </template>

                    <div class="booking-confirmed-modal-bts">
                        <a
                            :href="redirecturl"
                            class="btn btn-primary btn-filled-blue"
                            target="_self"
                            aria-describedby="Home Page"
                        >
                            Voltar à página inicial
                        </a>

                        <a
                            v-if="CheckoutData.booking.userisloged"
                            :href="professionaldashboard"
                            target="_self"
                            class="btn btn-secondary btn-filled-gray"
                            aria-describedby="Professional Dashboard"
                            >Dashboard</a
                        >
                    </div>
                </div>
            </template>
        </modal>

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </div>

    <div v-else>
        <h1>Os dados informados para Checkout não são válidos</h1>
    </div>
</template>

<script>
import htmlElements from "../../../htmlElements.js";
import calendarRoutine from "./../../../calendarScript.js";
import fetchData from "./../../../fetchData.js";
import inputValidation from "./../../../validationInputs.js";
import Modal from "./../../elements/ModalElement.vue";
import Loading from "../../elements/LoadingElement.vue";
import ListMessage from "./../../elements/ListMessageElement.vue";
import defaultScripts from "./../../../defaultWebsiteScript.js";
import Contract from "./Contract.vue";
import responseMessage from "./../../../responseMessage";

//Set Use Strict
("use strict");

export default {
    name: "Checkout",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        checkoutdata: {
            type: String,
            required: true,
        },
        checkoutnaviconcurrent: {
            type: String,
            required: true,
        },
        checkoutnavicondone: {
            type: String,
            required: true,
        },
        loginurl: {
            type: String,
            required: true,
        },
        createuserurl: {
            type: String,
            required: true,
        },
        contract: {
            type: String,
            required: true,
        },
        defaultpass: {
            type: String,
            required: true,
        },
        paymenturl: {
            type: String,
            required: true,
        },
        redirecturl: {
            type: String,
            required: true,
        },
        paymentmethods: {
            type: String,
            required: true,
        },
        professionaldashboard: {
            type: String,
            required: true,
        },
        enablefeedback: {
            type: String,
            required: true,
        },
        feedbackquestion: {
            type: String,
            required: true,
        },
        feedbackurl: {
            type: String,
            required: true,
        },
        imgdefaultpath: {
            type: String,
            required: true,
        },
        imgpaymentspath:{
            type: String,
            required: true,
        },
        paymentprocess: {
            type: String,
            required: true,
        }
    },
    data: () => {
        return {
            CheckoutData: {},
            IsValidRequestCheckout: true,
            mediadata: {},
            total: 0,
            disabled: true,
            billingAddress: true,
            name: "",
            email: "",
            address: "",
            postalcode: "",
            city: "",
            nif: "",
            contact: "",
            address_billing: "",
            postalcode_billing: "",
            city_billing: "",
            showPaymentContent: false,
            loginmail: "",
            loginpass: "",
            disabledlogin: true,
            inputNotIsValid: true,
            activeclass: "d-flex",
            professionalData: {
                login: {},
                account: {
                    data: {
                        file: {},
                    },
                    billing_address: {},
                },
                contract: false,
                contractfile: "",
                categories: [],
            },
            contractProfessionalData: {
                name: "",
                address: "",
                nif: "",
            },
            disabledpayment: true,
            paymentindicate: null,
            paymentData: {
                customerdata: {},
                productdata: {},
                billingdata: {},
                bookingdata: {},
                paymentdata: {},
            },
            useridfromcreateform: null,
            paymentMethods: {},
            feedbackQuestion: {},
            checkoutsendnumber: 1,
            checkoutsenddate: "",
            checkoutsendtoken: "",
            dateinstance: {},
            feedbackvalue: null,
            paymentProcess: 1,
            paymenturlplataform: '',
        };
    },
    created() {
        //Set Checkout Data
        this.CheckoutData = JSON.parse(this.checkoutdata);
        this.paymentMethods = JSON.parse(this.paymentmethods);
        this.paymentProcess = JSON.parse(this.paymentprocess);
        this.paymentProcess = parseInt(this.paymentProcess);

        //Set Checkout Feedback
        this.feedbackQuestion = JSON.parse(this.feedbackquestion);

        //Set Date
        this.dateinstance = new Date();
        this.checkoutsenddate = `${this.dateinstance.getDate()}/${
            this.dateinstance.getMonth() + 1
        }/${this.dateinstance.getFullYear()}`;

        //Set Checkout Feedback
        this.feedbackQuestion = JSON.parse(this.feedbackquestion);

        //Set Date
        this.dateinstance = new Date();
        this.checkoutsenddate = `${this.dateinstance.getDate()}/${
            this.dateinstance.getMonth() + 1
        }/${this.dateinstance.getFullYear()}`;

        //Check Token from Checkout Data Request
        if (Object.hasOwn(this.CheckoutData, "booking")) {
            //Set Checkout Token Conditional
            this.IsValidRequestCheckout = this.checkCheckoutToken(
                this.CheckoutData.booking.token
            );
            this.checkoutsendtoken = this.CheckoutData.booking.token;

            //Set Media Data
            this.mediadata =
                this.CheckoutData.booking.productdata.productdata.mediadata.find(
                    (value, index) => index === 0
                );
            this.mediadata = this.mediadata.thumbexist
                ? this.mediadata.media_middle
                : this.mediadata.media_original;

            //Set Total
            this.total = this.CheckoutData.booking.bookingdata.bookingtotal;

            //Set User is Logged Conditional
            this.disabled = this.CheckoutData.booking.userisloged
                ? false
                : true;

            //Check User Data
            if (this.CheckoutData.booking.userisloged) {
                //Set User Data
                this.name = this.CheckoutData.user.data.name;
                this.email = this.CheckoutData.user.data.email;
                this.nif = this.CheckoutData.user.data.nif;

                //Set User Billing
                let userBilling =
                    typeof this.CheckoutData.user.data.contact === "string"
                        ? JSON.parse(this.CheckoutData.user.data.contact)
                        : this.CheckoutData.user.data.contact;
                this.address = userBilling.billing_address.address;
                this.postalcode = userBilling.billing_address.postalcode;
                this.city = userBilling.billing_address.city;
            }
        } else {
            return this.turnBack();
        }
    },
    mounted() {
        //Check Token from Checkout Data Request
        if (Object.hasOwn(this.CheckoutData, "booking") && this.IsValidRequestCheckout) {
            //Set Booking Details List
            this.CheckoutData.booking.bookingdata.bookingdata.forEach(
                (value) => {
                    this.setBookingDetails(
                        value.turndata.subtotal,
                        `${value.turndata.subtotal} €`,
                        `${value.day}-${value.month}-${value.year}`,
                        value.turndata.begin,
                        value.turndata.end,
                        value.day,
                        value.turndata.totalhour,
                        value.month,
                        value.year
                    );
                }
            );
        }

        //Forget Token
        sessionStorage.removeItem("checkout");

    },
    methods: {
        sendFeedBackData(element) {
            //Confirm Feedback
            let confirmFeedback = confirm("Deseja enviar seu feedback ?");

            if (!confirmFeedback) {
                //Remove Class
                element.currentTarget.classList.remove("active");

                return;
            }

            //Remove Active Class
            [...document.querySelectorAll(".feedbackitens")].forEach((value) =>
                value.classList.remove("active")
            );

            //Add Active Class
            if (!element.currentTarget.classList.contains("active")) {
                element.currentTarget.classList.add("active");
            }

            //Set Feedback Value
            this.feedbackvalue = parseInt(
                element.currentTarget.getAttribute("data-value")
            );

            //Send Data
            this.sendData("feedback");
        },
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        showModal(classname) {
            //Disabled Button
            this.disabled = true;

            //Show Modal
            $(`.${classname}`).modal("show");
        },
        hideModal(classname) {
            //Hide Modal
            $(`.${classname}`).modal("hide");
        },
        showPass(inputElement, element) {
            defaultScripts.showPassword(inputElement, element.target);
        },
        checkCheckoutToken(token) {
            if (sessionStorage.getItem("pdp_checkout") !== null) {
                let tokenValid = JSON.parse(
                    sessionStorage.getItem("pdp_checkout")
                );

                return tokenValid === token;
            }

            return false;
        },
        setCheckoutSendDataValue(checkouttoken) {
            //Add Checkout Token
            sessionStorage.setItem(
                "checkout",
                JSON.stringify(btoa(checkouttoken))
            );
        },
        checkCheckoutSendDataValue(numbervalue) {
            if (sessionStorage.getItem("checkout") !== null) {
                let tokenValid = JSON.parse(sessionStorage.getItem("checkout"));

                //Decode Token
                tokenValid = atob(tokenValid);

                //Decode Structure - Date_Token_ProductId_Attempts
                let tokenValidSplit = tokenValid.split("_");
                let compareValue = [
                    this.checkoutsenddate,
                    this.CheckoutData.booking.token,
                    this.CheckoutData.booking.productdata.id.toString(),
                    numbervalue.toString(),
                ];

                //Check Values
                for (let i = 0; i < tokenValidSplit.length; i++) {
                    if (tokenValidSplit[i] !== compareValue[i]) {
                        return false;
                    }
                }

                return true;
            }

            return false;
        },
        turnBack() {
            return window.history.back();
        },
        billingAddressIndicate() {
            //Set new Conditional
            this.billingAddress = this.billingAddress ? false : true;
        },
        setBookingDetails(
            subtotalvalue,
            subtotal,
            date,
            begin,
            end,
            selectday,
            totalhour,
            month,
            year
        ) {
            //Append Li
            this.$refs.detailreservelist.appendChild(
                calendarRoutine.setBookingDetails(
                    subtotalvalue,
                    subtotal,
                    date,
                    begin,
                    end,
                    selectday,
                    totalhour,
                    false,
                    month,
                    year
                )
            );
        },
        buttonActions(element) {
            //Transition Image
            let image = "";

            //Check Routine
            switch (element.target.getAttribute("data-routine")) {
                //PDP
                case "pdp":
                    //Return for Pdp
                    //this.turnBack();
                    window.location.replace(
                        this.CheckoutData.booking.productdata.productdata.url
                    );

                    break;

                //Details
                case "details":
                    //Change Checkout Nav
                    image = document.querySelector(
                        `.checkout-${element.target.getAttribute(
                            "data-routine"
                        )}`
                    ).firstChild;
                    image.setAttribute("src", this.checkoutnaviconcurrent);

                    //Change Next Checkout Nav Icon
                    document
                        .querySelector(".checkout-payment")
                        .firstChild.setAttribute("src", "");
                    document
                        .querySelector(".checkout-payment")
                        .firstChild.setAttribute("alt", "");

                    //Set Show Payment Content
                    this.showPaymentContent = false;

                    break;

                //Payment
                case "payment":
                    //Required Inputs
                    let requiredInputsList = this.CheckoutData.booking
                        .userisloged
                        ? [
                              "name",
                              "email",
                              "address",
                              "postalcode",
                              "city",
                              "nif",
                          ]
                        : [
                              "name",
                              "email",
                              "contact",
                              "address",
                              "postalcode",
                              "city",
                              "nif",
                          ];

                    //Required
                    let required = this.checkRequiredInputs(requiredInputsList);

                    //Check Required
                    if (!required) {
                        //Render Response Message
                        responseMessage.renderResponseMessages(
                            this.$refs.responsebasemessage,
                            "danger",
                            "Todos os campos com * são de preenchimento obrigatório",
                            this.activeclass
                        );

                        return;
                    }

                    //Enabled Button
                    this.disabled = false;

                    //Check Action
                    switch (element.target.getAttribute("data-action")) {
                        //Create
                        case "create":
                            //Set Profissional Data
                            this.professionalData.login.email =
                                this.email.trim();
                            this.professionalData.login.password =
                                this.defaultpass;

                            //Set Professional Data
                            this.professionalData.account.data.name =
                                this.name.trim();
                            this.professionalData.account.data.contact =
                                this.contact.trim();
                            this.professionalData.account.data.address =
                                this.address.trim();
                            this.professionalData.account.data.postalcode =
                                this.postalcode.trim();
                            this.professionalData.account.data.city =
                                this.city.trim();
                            this.professionalData.account.data.nif =
                                this.nif.trim();

                            //Required Inputs
                            requiredInputsList = [
                                "address_billing",
                                "postalcode_billing",
                                "city_billing",
                            ];

                            //Required
                            required =
                                this.checkRequiredInputs(requiredInputsList);

                            //Check Required
                            if (!required && !this.billingAddress) {
                                //Render Response Message
                                responseMessage.renderResponseMessages(
                                    this.$refs.responsebasemessage,
                                    "danger",
                                    "Todos os campos com * são de preenchimento obrigatório",
                                    this.activeclass
                                );

                                return;
                            }

                            //Set BillingAddress
                            this.professionalData.account.billing_address.address =
                                this.billingAddress
                                    ? this.professionalData.account.data.address
                                    : this.address_billing.trim();
                            this.professionalData.account.billing_address.postalcode =
                                this.billingAddress
                                    ? this.professionalData.account.data
                                          .postalcode
                                    : this.postalcode_billing.trim();
                            this.professionalData.account.billing_address.city =
                                this.billingAddress
                                    ? this.professionalData.account.data.city
                                    : this.city_billing.trim();

                            //Remove Older Values
                            if (
                                document.getElementById(
                                    "professional-checkout-data"
                                )
                            ) {
                                document
                                    .getElementById(
                                        "professional-checkout-data"
                                    )
                                    .remove();
                            }

                            //Set Contract Professional Data
                            let address =
                                this.professionalData.account.data.address +
                                ", Código Postal: " +
                                this.professionalData.account.data.postalcode +
                                ", " +
                                this.professionalData.account.data.city;
                            //Get Contract Box Childrens
                            let childrens = [
                                ...document.getElementById("contract-box")
                                    .children,
                            ];

                            //Set Dynamic Professional Data input in the Contract
                            let newElement = htmlElements.createElement(
                                "p",
                                {
                                    class: "contract-editable-paragraph",
                                    id: "professional-checkout-data",
                                    contenteditable: true,
                                },
                                `Nome: ${this.professionalData.account.data.name}, 
                                Morada: ${address},
                                Nif: ${this.professionalData.account.data.nif}
                                `
                            );

                            //Set Professional Info
                            document
                                .getElementById("contract-box")
                                .insertBefore(newElement, childrens[0]);

                            //Show Modal Contract
                            this.showModal("contractcheckoutform");

                            break;

                        //process
                        case "process":
                            //Change Checkout Nav Icon
                            image = document.querySelector(
                                `.checkout-${element.target.getAttribute(
                                    "data-routine"
                                )}`
                            ).firstChild;
                            image.setAttribute(
                                "src",
                                this.checkoutnaviconcurrent
                            );
                            image.setAttribute("alt", "Checkout Nav Icon");

                            //Change Previous Checkout Nav Icon
                            document
                                .querySelector(".checkout-details")
                                .firstChild.setAttribute(
                                    "src",
                                    this.checkoutnavicondone
                                );

                            //Set Show Payment Content
                            this.showPaymentContent = true;

                            break;
                    }

                    break;
            }
        },
        inputValidationCase(inputid, inputvalue) {
            //Check Value
            if (inputvalue === "") {
                return;
            }

            //Check Inputs
            switch (inputid) {
                //Name
                case "name":
                    this.disabled = inputValidation.validNameCases(
                        1,
                        inputvalue
                    )
                        ? false
                        : true;

                    //Show Error Message
                    this.showInputErrorMessage(this.disabled, inputid);

                    //Set Conditional for input is valid
                    this.inputNotIsValid = this.disabled;

                    break;

                //Address
                case "address":
                case "address_billing":
                    this.disabled = inputValidation.validNameCases(
                        4,
                        inputvalue
                    )
                        ? false
                        : true;

                    //Show Error Message
                    this.showInputErrorMessage(this.disabled, inputid);

                    //Set Conditional for input is valid
                    this.inputNotIsValid = this.disabled;

                    break;

                //Email
                case "email":
                    this.disabled = inputValidation.validNameCases(
                        7,
                        inputvalue
                    )
                        ? false
                        : true;

                    //Show Error Message
                    this.showInputErrorMessage(this.disabled, inputid);

                    //Set Conditional for input is valid
                    this.inputNotIsValid = this.disabled;

                    break;

                //Contact
                case "contact":
                    this.disabled = inputValidation.validNameCases(
                        2,
                        inputvalue
                    )
                        ? false
                        : true;

                    //Show Error Message
                    this.showInputErrorMessage(this.disabled, inputid);

                    //Set Conditional for input is valid
                    this.inputNotIsValid = this.disabled;

                    break;

                //Postalcode
                case "postalcode":
                case "postalcode_billing":
                    //Check Length
                    if (
                        (inputvalue.length === 8 && inputvalue.includes("-")) ||
                        (inputvalue.length === 7 && !inputvalue.includes("-"))
                    ) {
                        this.disabled = inputValidation.validNameCases(
                            2,
                            inputvalue
                        )
                            ? false
                            : true;
                    } else {
                        this.disabled = true;
                    }

                    //Show Error Message
                    this.showInputErrorMessage(this.disabled, inputid);

                    //Set Conditional for input is valid
                    this.inputNotIsValid = this.disabled;

                    break;

                //Password
                case "password":
                    this.disabled = inputValidation.validNameCases(
                        11,
                        inputvalue
                    )
                        ? false
                        : true;

                    //Show Error Message
                    this.showInputErrorMessage(this.disabled, inputid);

                    //Set Conditional for input is valid
                    this.inputNotIsValid = this.disabled;

                    break;

                //City
                case "city":
                case "city_billing":
                    this.disabled = inputValidation.validNameCases(
                        1,
                        inputvalue
                    )
                        ? false
                        : true;

                    //Show Error Message
                    this.showInputErrorMessage(this.disabled, inputid);

                    //Set Conditional for input is valid
                    this.inputNotIsValid = this.disabled;

                    break;

                //Nif
                case "nif":
                    //Check Length
                    if (inputvalue.toString().length === 9) {
                        this.disabled = inputValidation.validNameCases(
                            12,
                            inputvalue
                        )
                            ? false
                            : true;

                        //Check Nif structure
                        if(!this.disabled){

                            this.disabled = inputValidation.isValidNif(inputvalue);

                        }

                    } else {
                        this.disabled = true;
                    }

                    //Show Error Message
                    this.showInputErrorMessage(this.disabled, inputid);

                    //Set Conditional for input is valid
                    this.inputNotIsValid = this.disabled;

                    break;

                //mailinput
                case "mailinput":
                    this.disabledlogin = inputValidation.validNameCases(
                        7,
                        inputvalue
                    )
                        ? false
                        : true;

                    //Show Error Message
                    this.showInputErrorMessage(this.disabledlogin, inputid);

                    //Set Conditional for input is valid
                    this.inputNotIsValid = this.disabledlogin;

                    break;

                //mailpassword
                case "mailpassword":
                    this.disabledlogin = inputValidation.validNameCases(
                        11,
                        inputvalue
                    )
                        ? false
                        : true;

                    //Show Error Message
                    this.showInputErrorMessage(this.disabledlogin, inputid);

                    //Set Conditional for input is valid
                    this.inputNotIsValid = this.disabledlogin;

                    break;
            }
        },
        checkRequiredInputs(requiredInputsList) {
            //Required
            let required = true;

            Object.keys(this.$data).forEach((valkey) => {
                const dataKey = Object.getOwnPropertyDescriptor(
                    this.$data,
                    valkey
                );

                //Check Empty Inputs
                if (
                    requiredInputsList.includes(valkey) &&
                    dataKey.value === ""
                ) {
                    required = false;
                }
            });

            return required;
        },
        showInputErrorMessage(conditional, inputid) {
            //Show Error Message
            if (conditional) {
                inputValidation.createErrorMessageElement(
                    inputid,
                    "Favor enviar dados válidos"
                );
            }
        },
        getProfessionalAgreement(agree) {
            //Get Contract Data
            this.professionalData.contractfile = agree.contract;

            //Set User Agreement
            this.professionalData.contract = agree.agreement;

            //Send Data
            this.sendData("create");
        },
        getPaymentMethod() {
            //Enabled Button
            this.disabledpayment = false;

            //Input is Valid
            this.inputNotIsValid = false;
        },
        checkBrowserForRedirect(){

            //navigator.userAgentData - add this conditional
            const ua = navigator.userAgent;

            const isSafari = ua.includes("Safari") && window.safari !== undefined && !ua.includes("Chrome") && !ua.includes("Chromium");

            return isSafari;

        },
        sendData(routine) {
            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Default Variables
            let url = "";
            let formData = {};
            let requiredInputsList = [];
            let required = true;

            //Set Variables from Routine
            switch (routine) {
                //Login
                case "login":
                    //Disabled Button
                    this.disabledlogin = true;

                    //Required Inputs
                    requiredInputsList = ["loginmail", "loginpass"];

                    //Required
                    required = this.checkRequiredInputs(requiredInputsList);

                    //Check Required
                    if (!required) {
                        //Desactive Loading
                        document
                            .querySelector(".loadingbase")
                            .classList.remove("d-flex");

                        //Render Response Message
                        responseMessage.renderResponseMessages(
                            this.$refs.responsebasemessage,
                            "danger",
                            "Todos os campos com * são de preenchimento obrigatório",
                            this.activeclass
                        );

                        return;
                    }

                    //Set Url
                    url = this.loginurl;

                    //Set Form Data
                    formData.email = this.loginmail.trim();
                    formData.password = this.loginpass.trim();

                    break;

                //Create Professional User
                case "create":
                    //Disabled Button
                    this.disabled = true;

                    //Required Inputs
                    requiredInputsList = [
                        "name",
                        "email",
                        "address",
                        "postalcode",
                        "city",
                        "nif",
                        "contact",
                    ];

                    //Required
                    required = this.checkRequiredInputs(requiredInputsList);

                    //Check Required
                    if (!required) {
                        //Desactive Loading
                        document
                            .querySelector(".loadingbase")
                            .classList.remove("d-flex");

                        //Render Response Message
                        responseMessage.renderResponseMessages(
                            this.$refs.responsebasemessage,
                            "danger",
                            "Todos os campos com * são de preenchimento obrigatório",
                            this.activeclass
                        );

                        return;
                    }

                    //Check Billing Address
                    if (!this.billingAddress) {
                        //Required Inputs
                        requiredInputsList = [
                            "address_billing",
                            "postalcode_billing",
                            "city_billing",
                        ];

                        //Required
                        required = this.checkRequiredInputs(requiredInputsList);

                        //Check Required
                        if (!required) {
                            //Desactive Loading
                            document
                                .querySelector(".loadingbase")
                                .classList.remove("d-flex");

                            //Render Response Message
                            responseMessage.renderResponseMessages(
                                this.$refs.responsebasemessage,
                                "danger",
                                "Todos os campos com * são de preenchimento obrigatório",
                                this.activeclass
                            );

                            return;
                        }
                    }

                    //Set Url
                    url = this.createuserurl;

                    //Set Form Data
                    Object.assign(formData, this.professionalData);

                    break;

                //Payment
                case "payment":
                    //===> Develop one more security layer for NIF

                    //Disabled Button
                    this.disabledpayment = true;

                    //Required Inputs
                    requiredInputsList = [
                        "name",
                        "email",
                        "address",
                        "postalcode",
                        "city",
                        "nif",
                    ];

                    //Required
                    required = this.checkRequiredInputs(requiredInputsList);

                    //Check Required
                    if (!required) {
                        //Desactive Loading
                        document
                            .querySelector(".loadingbase")
                            .classList.remove("d-flex");

                        //Render Response Message
                        responseMessage.renderResponseMessages(
                            this.$refs.responsebasemessage,
                            "danger",
                            "Todos os campos com * são de preenchimento obrigatório",
                            this.activeclass
                        );

                        return;
                    }

                    //Set Payment Product Data
                    this.paymentData.productdata.product_id =
                        this.CheckoutData.booking.productdata.id;
                    this.paymentData.productdata.company_id =
                        this.CheckoutData.booking.productdata.company_id;
                    this.paymentData.productdata.product_name =
                        this.CheckoutData.booking.productdata.productdata.name;
                    this.paymentData.productdata.product_address = `${this.CheckoutData.booking.productdata.productdata.address}, ${this.CheckoutData.booking.productdata.productdata.location_name}`;
                    this.paymentData.productdata.product_image = this.mediadata;

                    //Set Payment Booking Data
                    this.paymentData.bookingdata.data =
                        this.CheckoutData.booking.bookingdata.bookingdata;
                    this.paymentData.bookingdata.month =
                        this.CheckoutData.booking.bookingdata.bookingmonth;
                    this.paymentData.bookingdata.year =
                        this.CheckoutData.booking.bookingdata.bookingyear;
                    this.paymentData.bookingdata.typeoflocation =
                        this.CheckoutData.booking.bookingdata.bookingtypeoflocation;
                    this.paymentData.bookingdata.total = this.total;

                    //Set Payment Customer Data
                    this.paymentData.customerdata.user_id = this.CheckoutData
                        .booking.userisloged
                        ? this.CheckoutData.user.user_id
                        : this.useridfromcreateform;

                    //Set Payment Billing Data
                    this.paymentData.billingdata.name = this.name.trim();
                    this.paymentData.billingdata.email = this.email.trim();
                    this.paymentData.billingdata.nif = parseInt(this.nif);
                    this.paymentData.billingdata.address =
                        this.address_billing === ""
                            ? this.address.trim()
                            : this.address_billing.trim();
                    this.paymentData.billingdata.postalcode =
                        this.postalcode_billing === ""
                            ? this.postalcode.toString().trim()
                            : this.postalcode_billing.toString().trim();
                    this.paymentData.billingdata.city =
                        this.city_billing === ""
                            ? this.city.trim()
                            : this.city_billing.trim();

                    //Set Payment Data
                    this.paymentData.paymentdata.type = parseInt(
                        this.paymentindicate
                    );

                    //Set Url
                    url = this.paymenturl;

                    //Set Form Data
                    Object.assign(formData, this.paymentData);

                    //Set Checkout Send Data Token
                    this.setCheckoutSendDataValue(
                        `${this.checkoutsenddate}_${this.checkoutsendtoken}_${this.CheckoutData.booking.productdata.id}_${this.checkoutsendnumber}`
                    );

                    //Check Checkout Send Data Token
                    if (
                        !this.checkCheckoutSendDataValue(
                            this.checkoutsendnumber
                        )
                    ) {
                        //Desactive Loading
                        document
                            .querySelector(".loadingbase")
                            .classList.remove("d-flex");

                        //Hide Payment Response
                        this.hideModal("checkoutpaymentresponse");

                        //Forget Token
                        sessionStorage.removeItem("checkout");

                        //Show Error Message

                        //Render Response Message
                        responseMessage.renderResponseMessages(
                            this.$refs.responsebasemessage,
                            "danger",
                            "Seu pedido de reserva já foi processado",
                            this.activeclass
                        );

                        //Redirect for Home Page
                        window.location.replace(this.redirecturl);

                        return;
                    }

                    //Increment Send Number
                    this.checkoutsendnumber++;

                    break;

                //Feedback
                case "feedback":
                    //Set Url
                    url = this.feedbackurl;

                    //Get FeedBack Data
                    formData = {
                        data: {
                            value: this.feedbackvalue,
                        },
                        user_id: this.paymentData.customerdata.user_id,
                        type: "checkout",
                        office_id: this.CheckoutData.booking.productdata.id,
                    };

                    break;
            }

            //Check if the input data is valid
            if (this.inputNotIsValid) {
                //Desactive Loading
                document
                    .querySelector(".loadingbase")
                    .classList.remove("d-flex");

                //Render Response Message
                responseMessage.renderResponseMessages(
                    this.$refs.responsebasemessage,
                    "danger",
                    "Os dados enviados não são válidos",
                    this.activeclass
                );

                return;
            }

            //Send Data
            let response = fetchData.structureTosendData(
                url,
                formData,
                this.csrftolken,
                "POST"
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Add active Class
                    this.$refs.responsebasemessage.classList.add(
                        this.activeclass
                    );
                    this.$refs.responsebasemessage.classList.add(
                        value.classname
                    );

                    //Check Type
                    if (Array.isArray(value.message)) {
                        value.message.forEach((valmsg) => {
                            //Element for append
                            let li = responseMessage.messageStructure(
                                valmsg,
                                value.classname
                            );

                            //Append Element
                            $(li).appendTo(
                                this.$refs.responsebasemessage.children
                            );
                        });

                        return;
                    }

                    //Element for append
                    let li = responseMessage.messageStructure(
                        value.message,
                        value.classname
                    );

                    //Append Element
                    $(li).appendTo(this.$refs.responsebasemessage.children);

                    //Remove Message
                    responseMessage.removeResponseMessages(10000);

                    //Redirect User
                    if (
                        Object.is(value.classname, "success") ||
                        Object.is(value.classname, "warning")
                    ) {
                        //Data Routine
                        switch (value.data) {
                            //login
                            case "login":
                                //Hide Modal
                                this.hideModal("logincheckoutform");

                                //Reload Checkout
                                setTimeout(() => {

                                    window.location.reload();

                                }, 3000);
                                
                                break;

                            //Create
                            case "create":
                                //Hide Modal
                                this.hideModal("contractcheckoutform");

                                //Hide Login Content
                                document
                                    .querySelector(".login-content")
                                    .classList.add("d-none");

                                //Change Checkout Nav Icon
                                let image =
                                    document.querySelector(
                                        ".checkout-payment"
                                    ).firstChild;
                                image.setAttribute(
                                    "src",
                                    this.checkoutnaviconcurrent
                                );
                                image.setAttribute("alt", "Checkout Nav Icon");

                                //Change Previous Checkout Nav Icon
                                document
                                    .querySelector(".checkout-details")
                                    .firstChild.setAttribute(
                                        "src",
                                        this.checkoutnavicondone
                                    );

                                //Set User Id
                                this.useridfromcreateform = parseInt(
                                    value.userId
                                );

                                //Set Show Payment Content
                                this.showPaymentContent = true;

                                break;

                            //Payment
                            case "payment":

                                //Disabled Button
                                this.disabledpayment = true;

                                //Forget Token
                                sessionStorage.removeItem('pdp_checkout');
                                
                                //Show Payment Integration Window
                                if(this.paymentProcess){

                                    //Set Payment Plataform Url
                                    this.paymenturlplataform = value.execute;

                                    //Check Browser
                                    if(!this.checkBrowserForRedirect()){

                                        window.open(value.execute, "_blank");

                                    }else{

                                        window.location.replace(value.execute);

                                    }

                                }else{

                                    //Redirect for Home Page
                                    setTimeout(() => {
                                        window.location.replace(this.redirecturl);
                                    }, 300000);

                                }

                                //Show Payment Response
                                this.showModal("checkoutpaymentresponse");

                                break;

                            //Feedback
                            case "feedback":
                                //Remove element and add response
                                [...this.$refs.feedbackbase.children].forEach(
                                    (value) => value.remove()
                                );

                                //Create Response Element
                                let feedbackresponse =
                                    htmlElements.createElement(
                                        "p",
                                        {
                                            class: "w-100",
                                        },
                                        "Agradecemos por sua participação"
                                    );

                                //Append Response
                                this.$refs.feedbackbase.appendChild(
                                    feedbackresponse
                                );

                                //Redirect for Home Page
                                setTimeout(() => {
                                    //Forget Token
                                    //sessionStorage.removeItem('pdp_checkout');

                                    window.location.replace(this.redirecturl);
                                }, 910000);

                                break;
                        }
                    }

                    //When Have an Error
                    this.hideModal("contractcheckoutform");

                    return;
                })
                .catch((error) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
    },
    computed: {
        computedProfessionalData() {
            return this.professionalData;
        },
        computedContractProfessionalData() {
            return this.contractProfessionalData;
        },
        computedPaymentData() {
            return this.paymentData;
        },
    },
    watch: {
        computedProfessionalData() {},
        computedContractProfessionalData() {},
        computedPaymentData() {},
    },
    components: {
        modal: Modal,
        loading: Loading,
        listMessage: ListMessage,
        contract: Contract,
    },
};
</script>
